
import React,{useState} from "react";
import HeaderAdmin from '../../Components/HeaderAdmin'
import usePrivilegios from '../../Hooks/usePrivilegios';
import useReseñas from "../../Hooks/useReseñas";
import styled from "styled-components";

import { Bar,Line } from 'react-chartjs-2';

import {CategoryScale, Chart ,registerables  } from 'chart.js'; 
import Carousel from 'react-material-ui-carousel'


import { Scrollbars } from 'react-custom-scrollbars';
import { CircularProgress,Tabs,Tab,Box,Typography  } from "@material-ui/core";
import { makeStyles,withStyles } from '@material-ui/core/styles';
import MUIDataTable from "mui-datatables";


const useStyles = makeStyles({
    root: {
      flexGrow: 1,
    },
    TabPanel:{}
});

const CenteredTabs = withStyles({
  flexContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f5f3f3',
    paddingTop: '15px',
  },
 
})(Tabs);

const Container = styled.div`
min-height: calc(100vh - 63px);
background-color:#f5f3f3;
display: flex;
justify-content: center;
/* padding:15px; */
`;

const Section = styled.div`
padding:24px ;
border-radius:8px;
background-color:white;
margin:15px 0 ;
`;

const ContainerChart = styled.div`
width:50vw;`;

const ContainerSugerencia = styled.div`
border-radius:4px;
background-color:#f8f9fa;
margin:15px 0;
padding:8px;
`;





function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div

      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box style={{margin:"0"}}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const Suguerencia = ({sugerencia}) =>
{
  const TextoMesa = sugerencia.Mesa === "No especificada" ? "" : `| Mesa ${sugerencia.Mesa}`;
  return <ContainerSugerencia>{sugerencia.Fecha} - {sugerencia.Sugerencia} {TextoMesa}</ContainerSugerencia>
}

const Detalles = ({Reviews}) =>
{
  const Columns = 
  [
    {label:"Fecha",name:"Fecha"},
    {label:"Mesa",name:"Mesa",options:{customBodyRender:((value) => {return value === "No especificada" ? "❌" : value})}},
    {label:"Teléfono",name:"Telefono",options:{customBodyRender:((value) => {return value === undefined ? "❌" : value})}},
    {label:"Ambientación",name:"Ambientacion"},
    {label:"Atención",name:"Atencion"},
    {label:"Bebida",name:"Bebida"},
    {label:"Comida",name:"Comida"},
  ]

  const Labels = 
  {
    body: 
    {
      noMatch: "No se han encontrado reseñas",
      toolTip: "Sort",
      columnHeaderTooltip: column => `Ordenar por ${column.label}`
    },
    pagination: 
    {
      next: "Siguente página",
      previous: "Página anterior",
      rowsPerPage: "reseñas por página:",
      displayRows: "de",
    },
    toolbar: 
    {
      search: "Buscar reseñas",
      downloadCsv: "Imprimir CSV",
      print: "Imprimir",
      viewColumns: "Ver columnas",
      filterTable: "Filtrar tabla",
    },
    filter: 
    {
      all: "Todos",
      title: "Filtros",
      reset: "Resetear",
    },
    viewColumns: 
    {
      title: "Ver columnas",
      titleAria: "Ver/ocultar columnas",
    },
    selectedRows: 
    {
      text: "Reseña(s) a borrar",
      delete: "Borrar"
    }
  }

  return <Section>
    <MUIDataTable title="Reseñas" data={Reviews} columns={Columns}  options={{selectableRows:false,print:false,download:false,textLabels:Labels}}/>
  </Section>
}

const General = ({Reviews,Promedio,Sugerencias,GraphLine}) =>
{
  const options = 
  {
    responsive:true,
      scales: {
        xAxes: [
          {
            type: 'category',
            labels: ['Ambientación', 'Atención' , 'Bebida', 'Comida'],
          },
        ],
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              max: 5,
              min: 0,
            },
          },
        ],
      },
  };

  const optionsLine = {
    scales:
    {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            suggestedMax: 3,
            max: 2,
            min: 0,
          },
        },
      ],
    },
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: false,
      },
    },
  };
  

  return  <ContainerChart>

  <Section>
    <p>{Reviews.length} {Reviews.length === 1 ? 'Review' : 'Reviews'}</p>
    <Carousel>
    <Bar data={Promedio} options={options}/>
    <Line data={GraphLine} options={optionsLine}/>
    </Carousel>
  </Section>

  <Section>
      <p>{Sugerencias.length} {Sugerencias.length === 1 ? 'Sugerencia' : 'Sugerencias'}</p>
      <Scrollbars autoHide   style={{ height: 300 }}>
          {Sugerencias.map(sugerencia => 
          {
            return <Suguerencia sugerencia={sugerencia}/>
          })}
      </Scrollbars>
  </Section>

</ContainerChart>
}


const Reseñas = () => 
{
  usePrivilegios();
  const classes = useStyles();
  
  const [Pagina, setPagina] = useState(0);

  Chart.register(...registerables);

  const {Reviews,Promedio,Sugerencias,GraphLine,Loading} = useReseñas(); 

  const handleChangePaginas = (event, newValue) => {
    setPagina(newValue);
  };

  if(Loading)
  {
    return <div>
        <HeaderAdmin  title={"Reseñas"}/>
        <Container>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <CircularProgress style={{ height: '100px', width: '100px' }} />
        </div>
        </Container>
    </div>
  }

  return <>
      <HeaderAdmin  title={"Reseñas"}/>
      <CenteredTabs value={Pagina} onChange={handleChangePaginas} style={{justifyContent:"center"}}>
          <Tab label="General"/>
          <Tab label="Detalles"/>
      </CenteredTabs>

      <Container>
          <TabPanel value={Pagina} index={0} className={classes.TabPanel}>
            <General Reviews={Reviews} Promedio={Promedio} Sugerencias={Sugerencias} GraphLine={GraphLine}/>
          </TabPanel>
          <TabPanel value={Pagina} index={1} className={classes.TabPanel}>
            <Detalles Reviews={Reviews}/>
          </TabPanel>
      </Container>
  </>
}

export default Reseñas;